import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getLeague } from "../../api/leagues";
import EditLeague from "../../components/Leagues/EditLeague";
import { AlertUserSessionExpiredToken } from "../../components/AlertUserSessionExpiredToken";
import { toastError } from "../../helpers/notificationHelpers";

const EditLeaguePage = () => {
	const params = useParams();
	const navigate = useNavigate();
	const [league, setLeague] = useState();

	useEffect(() => {
		const loadLeague = async () => {
			if (!params.identifier) {
				return;
			}

			try {
				const response = await getLeague(params.identifier);

				if (!response || !response.data?.Result) {
					toastError("No fue posible cargar la liga.");
					return;
				}

				setLeague(response.data.Result);
			} catch (error) {
				toastError("No fue posible cargar la liga.");
			}
		};

		loadLeague();
	}, [params.identifier]);

	const handleLeagueSaved = () => {
		navigate("/leagues");
	};

	return (
		<React.Fragment>
			<div className='container py-4'>
				<AlertUserSessionExpiredToken />
				<h4>Editar liga</h4>
				<hr />
				{league && <EditLeague league={league} onSave={handleLeagueSaved} />}
			</div>
		</React.Fragment>
	);
};

export default EditLeaguePage;